/**
 * Input Schema of RastreamentoHistorico
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {RastreamentoHistorico} from '@/model/resource/RastreamentoHistorico'
import {RastreamentoCollection} from '@/model/collection/RastreamentoCollection'

/* TODO: review generated schema */
export class InputRastreamentoHistoricoSchema extends Schema {
  collectionRastreamento = new RastreamentoCollection().noPagination()

  readonly name = 'InputRastreamentoHistorico'

  readonly fieldSet: FieldSet<RastreamentoHistorico> = {
    rastreamento: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionRastreamento.all(),
      },
    }),
    latitude: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        maxlength: 255,
        step: 'any',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    longitude: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        maxlength: 255,
        step: 'any',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    dataPosicao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    statusCarga: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    idExterno: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 25,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
